import * as React from "react";
import ModalWrap from "../common/modal";
import RedeemCodeDataDownload from "./RedeemCodeDataDownload";

export class ViewRedeemCodeDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false,
      closable: true,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <ModalWrap
        visible={this.props.isVisible}
        closable={this.props.onClose}
        title="Redeem Data Download"
        onOk={this.props.onClose}
        onCancel={this.props.onClose}
        isLoading={this.state.isLoading}
        width="1000px"
      >
        <RedeemCodeDataDownload
          data={this.props.uploadRedeemData}
          authToken={this.props.authToken}
          onClose={this.props.onClose}
          loginUserData={this.props.loginUserData}
        />
      </ModalWrap>
    );
  }
}
